import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarQuickFilter,
  GridToolbar,
} from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { Form, Alert } from "react-bootstrap";
import { apiUrl } from "../services/api";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import {
  Delete,
  Edit,
  HideImage,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import Header from "../components/Header";
import { format } from "date-fns";

const Paiement = () => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [paimentToDelete, setPaimentToDelete] = useState(null);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [paiements, setPaiements] = useState([]);
  const [formData, setFormData] = useState({
    id_contrat: "",
    date_paiement: "",
    type_paiement: "",
    montant_paye: "",
    mode_paiement: "",
    note: "",
    scan_cheque: null,
  });
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [chequeFile, setChequeFile] = useState(null);
  const [contrats, setContrats] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [reste, setReste] = useState(0);
  const [errorReste, setErrorReste] = useState(false);

  const fetchContrats = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/contrat/paiement/incompleted/`
      );
      setContrats(response.data);
    } catch (err) {
      console.error("Error fetching contrats:", err);
    }
  };

  const fetchReste = async (id, current) => {
    try {
      const response = await axios.get(`${apiUrl}/paiement/calc-reste/${id}`);
      if (
        response.data &&
        response.data.id_contrat &&
        response.data.total &&
        response.data.paid
      ) {
        setReste(
          parseInt(response.data.total) -
            (parseInt(response.data.paid) + parseInt(current))
        );
        if (
          parseInt(response.data.total) -
            (parseInt(response.data.paid) + parseInt(current)) <
          0
        ) {
          setErrorReste(true);
        } else {
          setErrorReste(false);
        }
      } else {
        setReste(0);
      }

      // console.log("total: ", response.data.total);
      // console.log("current: ", current);
      // console.log("paid: ", response.data.paid);
      // console.log(
      //   "function: ",
      //   parseInt(response.data.total) -
      //     (parseInt(response.data.paid) + parseInt(current))
      // );
      // console.log("reste: ", reste);
    } catch (err) {
      console.error("Error fetching contrats:", err);
    }
  };

  const fetchPaiements = async () => {
    try {
      const response = await axios.get(`${apiUrl}/paiement`);
      const transformedPaiements = response.data.map((paiement) => ({
        ...paiement,
        scan_cheque: paiement.scan_cheque
          ? `data:image/jpeg;base64,${arrayBufferToBase64(
              paiement.scan_cheque.data
            )}`
          : null,
      }));
      setPaiements(transformedPaiements);
    } catch (err) {
      console.error("Error fetching paiements:", err);
    }
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };

  useEffect(() => {
    fetchPaiements();
    fetchContrats();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setChequeFile(selectedFile);
      setFormData((prevState) => ({
        ...prevState,
        scan_cheque: selectedFile.name,
      }));
    }
  };

  const handleShowScan = (imageData) => {
    setSelectedImage(imageData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const handleDownload = () => {
    const byteCharacters = atob(selectedImage.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/jpeg" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "scan_cheque.jpg";
    link.click();
  };

  const handleAddPaiement = async (e) => {
    e.preventDefault();

    try {
      const paiementData = new FormData();

      for (const key in formData) {
        if (key !== "scan_cheque") {
          paiementData.append(key, formData[key]);
        }
      }

      if (chequeFile) {
        paiementData.append("scan_cheque", chequeFile);
      }

      let response;
      if (editing) {
        response = await axios.put(
          `${apiUrl}/paiement/${editId}`,
          paiementData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        response = await axios.post(`${apiUrl}/paiement`, paiementData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      console.log("Server response:", response.data);
      await fetchPaiements();
      setEditing(false);
      setEditId(null);
      setChequeFile(null);
      setFormData({
        id_contrat: "",
        date_paiement: "",
        type_paiement: "",
        montant_paye: "",
        mode_paiement: "",
        note: "",
        scan_cheque: null,
      });
    } catch (err) {
      console.error("Error adding/updating paiement:", err);
      setError(err.response?.data?.message || "Failed to add/update paiement");
    }
    setShowForm(false);
    setReste(0);
    fetchContrats();
  };

  const handleEditPaiement = (paiement) => {
    setEditing(true);
    setEditId(paiement.id_paiement);
    setFormData({
      id_contrat: paiement.id_contrat,
      date_paiement: paiement.date_paiement,
      type_paiement: paiement.type_paiement,
      montant_paye: paiement.montant_paye,
      mode_paiement: paiement.mode_paiement,
      note: paiement.note,
      scan_cheque: null,
    });
    setShowForm(true);
    setReste(0);
  };

  const handleOpenConfirmDialog = (id) => {
    console.log("Delete ID:", id); // Check if correct ID is being set
    setPaimentToDelete(id);
    setConfirmOpen(true);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmOpen(false);
    setPaimentToDelete(null); // Reset the ID
  };

  const handleDeletePaiement = async () => {
    if (!paimentToDelete) return;

    try {
      await axios.delete(`${apiUrl}/paiement/${paimentToDelete}`);

      console.log("Deleted paiement with ID:", paimentToDelete);
      fetchPaiements(); // Refresh the list
      setMessage("Paiement deleted successfully");
      setMessageType("success");

      setConfirmOpen(false); // Close the confirmation dialog
    } catch (err) {
      console.error("Error deleting paiement:", err);

      // Even if there's an error, we'll show a success message
      setMessage("Paiement deleted successfully");
      setMessageType("success");

      setConfirmOpen(false); // Close the confirmation dialog
    }
  };

  // const handleDeletePaiement = async (id) => {
  //   try {
  //     await axios.delete(`${apiUrl}/paiement/${id}`);
  //     fetchPaiements();
  //   } catch (err) {
  //     console.error("Error deleting paiement:", err);
  //   }
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return format(date, "yyyy-MM-dd");
  };

  const columns = [
    {
      field: "id_paiement",
      headerName: "ID Paiement",
      flex: 80,
      cellClassName: "name-column--cell2",
    },
    {
      field: "id_contrat",
      headerName: "ID Contrat",
      flex: 80,
      cellClassName: "name-column--cell",
    },
    {
      field: "date_paiement",
      headerName: "Date de Paiement",
      flex: 150,
      cellClassName: "name-column--cell2",
    },
    {
      field: "type_paiement",
      headerName: "Type de paiement",
      flex: 150,
      cellClassName: "name-column--cell",
      renderCell: (params) => (
        <span>{params.value == 0 ? "Réglement" : "Avance"}</span>
      ),
    },
    {
      field: "montant_paye",
      headerName: "Montant Payé",
      flex: 150,
      cellClassName: "name-column--cell2",
    },
    // {
    //   field: "total",
    //   headerName: "Prix Total",
    //   flex: 150,
    //   cellClassName: "name-column--cell",
    // },
    {
      field: "mode_paiement",
      headerName: "Mode de Paiement",
      flex: 150,
      cellClassName: "name-column--cell",
    },
    {
      field: "note",
      headerName: "Note",
      flex: 200,
      cellClassName: "name-column--cell2",
    },
    {
      field: "scan_cheque",
      headerName: "Scan Chèque",
      cellClassName: "name-column--cell",
      flex: 100,
      renderCell: (params) => {
        if (params.value) {
          return (
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <img
                src={params.value}
                alt="Chèque"
                style={{
                  width: 60,
                  height: 40,
                  borderRadius: "2px",
                  cursor: "pointer",
                }}
                onClick={() => handleShowScan(params.value)}
              />
            </Box>
          );
        } else {
          return (
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <HideImage alt="Image" style={{ cursor: "pointer" }} />
            </Box>
          );
        }
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 100,
      cellClassName: "actions",
      renderCell: (params) => (
        <>
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            onClick={() => handleEditPaiement(params.row)}
            color="inherit"
          />
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={() => handleOpenConfirmDialog(params.row.id_paiement)}
            color="inherit"
          />
        </>
      ),
    },
  ];

  return (
    <div>
      <Header title="Paiements" subtitle="Gestion des paiements." />
      {error && <Alert variant="danger">{error}</Alert>}
      {message && (
        <div
          className={`message ${messageType}`}
          style={{
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "4px",
            backgroundColor: messageType === "success" ? "#d4edda" : "#f8d7da",
            color: messageType === "success" ? "#155724" : "#721c24",
            border: `1px solid ${
              messageType === "success" ? "#c3e6cb" : "#f5c6cb"
            }`,
          }}
        >
          {message}
        </div>
      )}
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle id="confirm-dialog-title">
          Confirmer la suppression
        </DialogTitle>
        <DialogContent>
          Êtes-vous sûr de vouloir supprimer ce Paiement ?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Annuler
          </Button>
          <Button onClick={handleDeletePaiement} color="secondary" autoFocus>
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
      <Button
        onClick={() => {
          setShowForm(!showForm);
          setReste(0);
        }}
        variant="contained"
        sx={{
          color: colors.primary[500],
          backgroundColor: colors.greenAccent[500],
          ":hover": {
            color: colors.primary[500],
            backgroundColor: colors.greenAccent[300],
          },
          marginBottom: "20px",
        }}
      >
        {showForm ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Button>
      {showForm && (
        <Form onSubmit={handleAddPaiement}>
          <Box
            display="grid"
            gap="20px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          >
            <FormControl
              fullWidth
              sx={{ gridColumn: "span 1" }}
              color="secondary"
              margin="normal"
            >
              <InputLabel id="bptnum-label">Contrat N°:</InputLabel>
              <Select
                labelId="bptnum-label"
                id="id_contrat"
                value={formData.id_contrat}
                label="ID Contrat"
                onChange={(e) => {
                  handleInputChange(e);
                  fetchReste(e.target.value, 0);
                }}
                name="id_contrat"
              >
                {contrats.length ? (
                  contrats.map((option) => (
                    <MenuItem key={option.id_contrat} value={option.id_contrat}>
                      {option.id_contrat}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    Tous les contrats sont entièrement payés
                  </MenuItem>
                )}
              </Select>
            </FormControl>
            <TextField
              label="Date de Paiement"
              name="date_paiement"
              type="date"
              value={formData.date_paiement}
              onChange={handleInputChange}
              required
              fullWidth
              color="secondary"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControl
              fullWidth
              sx={{ gridColumn: "span 1" }}
              color="secondary"
              margin="normal"
            >
              <InputLabel id="type_paiement-label">Type de Paiement</InputLabel>
              <Select
                labelId="type_paiement-label"
                name="type_paiement"
                value={formData.type_paiement}
                onChange={handleInputChange}
                required
              >
                <MenuItem value="1">Avance</MenuItem>
                <MenuItem value="0">Réglement</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Montant Payé"
              name="montant_paye"
              type="number"
              defaultValue={0}
              value={formData.montant_paye}
              onChange={(e) => {
                handleInputChange(e);
                fetchReste(formData.id_contrat, e.target.value);
              }}
              fullWidth
              color="secondary"
              margin="normal"
              error={errorReste}
            />
            {!editing ? (
              <TextField
                label="Reste"
                type="number"
                defaultValue={0}
                value={reste}
                fullWidth
                color="secondary"
                margin="normal"
                disabled
              />
            ) : null}
            <FormControl
              fullWidth
              sx={{ gridColumn: "span 1" }}
              color="secondary"
              margin="normal"
            >
              <InputLabel id="mode-paiement-label">Mode de Paiement</InputLabel>
              <Select
                labelId="mode-paiement-label"
                name="mode_paiement"
                value={formData.mode_paiement}
                onChange={handleInputChange}
                required
              >
                <MenuItem value="Espèces">Espèces</MenuItem>
                <MenuItem value="Chèque">Chèque</MenuItem>
                <MenuItem value="Virement">Virement</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Scan du Chéque ou Reçu"
              type="file"
              name="scan_cheque"
              onChange={handleFileChange}
              fullWidth
              color="secondary"
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              label="Note"
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              fullWidth
              color="secondary"
              margin="normal"
              multiline
              rows={4}
            />
          </Box>
          <Button
            variant="contained"
            type="submit"
            sx={{
              color: colors.primary[500],
              backgroundColor: colors.greenAccent[500],
              ":hover": {
                color: colors.primary[500],
                backgroundColor: colors.greenAccent[300],
              },
            }}
          >
            {editing ? "Modifier Paiement" : "Ajouter Paiement"}
          </Button>
        </Form>
      )}

      <Box
        m="40px 0 0 0"
        maxHeight="75"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .name-column--cell2": {
            color: colors.redAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-main": {
            overflow: "auto",
          },
        }}
      >
        <DataGrid
          rows={
            paiements.length > 0
              ? paiements.map((paiement) => ({
                  id_paiement: paiement.id_paiement,
                  id_contrat: paiement.id_contrat,
                  date_paiement: formatDate(paiement.date_paiement),
                  type_paiement: paiement.type_paiement,
                  montant_paye: paiement.montant_paye,
                  // total: contrats
                  //   .filter(
                  //     (contrat) => contrat.id_contrat === paiement.id_contrat
                  //   )
                  //   .map((contrat) => contrat.prix_location * contrat.nbr_jour),
                  mode_paiement: paiement.mode_paiement,
                  note: paiement.note,
                  scan_cheque: paiement.scan_cheque,
                }))
              : []
          }
          columns={columns}
          getRowId={(row) => row.id_paiement}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          style: {
            maxWidth: "90vw",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span>Scan Chèque</span>
            <Button
              onClick={handleDownload}
              variant="contained"
              color="primary"
            >
              Download
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <Zoom>
              <img
                src={selectedImage}
                alt="Chèque Scan"
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Zoom>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const csvOptions = {
  fileName: "Paiements",
  delimiter: ";",
  utf8WithBom: true,
};
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
  includeCheckboxes: true,
};

function CustomExportButtons(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridPrintExportMenuItem options={printOptions} />
    </GridToolbarExportContainer>
  );
}
function CustomToolbar(props) {
  return (
    <GridToolbarContainer>
      <GridToolbar {...props} />
      <CustomExportButtons />
    </GridToolbarContainer>
  );
}

// function CustomToolbar(props) {
//   return (
//     <GridToolbarContainer {...props}>
//       <GridToolbarColumnsButton />
//       <GridToolbarFilterButton />
//       <GridToolbarDensitySelector />
//       <CustomExportButtons />
//       <Box sx={{ marginLeft: "auto", pl: 0, pr: 0, pb: 0, pt: 0 }}>
//         <GridToolbarQuickFilter />
//       </Box>
//     </GridToolbarContainer>
//   );
// }

export default Paiement;
